<template lang="pug">
transition(name="cookie-fade")
    div.cookie-consent(v-if="visible")
        div.container
            div.cookie-row
                div.cookie-message
                    p.text
                        | {{ $t('$cookie.message') }} {{ $t('$cookie.more') }}&nbsp;
                        router-link.menu.with-border(:to="getLocalizedUrl('/politika-konfidencialnosti')") {{ $t('$cookie.policyInflected') }}
                        | .
                div.cookie-buttons
                    button.cookie-btn.cookie-btn-secondary(@click="reject") {{ $t('$cookie.reject') }}
                    button.cookie-btn.cookie-btn-primary(@click="accept") {{ $t('$cookie.accept') }}
</template>

<script>
import { getConsent, setConsent, initYandexMetrika } from '@/utils/yandexMetrika.js'

export default {
    name: 'cookie-consent',
    data() {
        return {
            visible: false,
        }
    },
    mounted() {
        const consent = getConsent()
        if (consent === 'accepted') {
            initYandexMetrika(this.$router)
        } else if (!consent) {
            this.visible = true
        }
    },
    methods: {
        accept() {
            setConsent('accepted')
            initYandexMetrika(this.$router)
            this.visible = false
        },
        reject() {
            setConsent('rejected')
            this.visible = false
        },
    },
}
</script>

<style lang="scss">
@import "@styles/mixins.scss";

.cookie-consent {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    background: #ffffff;
    color: #000;
    border-top: 1px solid #e5e5e5;
    box-shadow: 0 -8px 24px rgba(0, 0, 0, 0.08);
    padding: 20px 0;

    .cookie-row {
        display: flex;
        align-items: center;
        gap: 30px;
    }

    .cookie-message {
        flex: 1;

        p.text {
            color: #000 !important;
            margin: 0;
            line-height: 1.5;
            font-size: 14px;
            letter-spacing: -0.2px;
        }

        .menu {
            font: inherit;
            line-height: inherit;
            letter-spacing: inherit;
            color: #000 !important;
            cursor: pointer;

            &:hover {
                color: #666 !important;
            }
        }

        .with-border {
            border-bottom: 1px solid;
        }
    }

    .cookie-buttons {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-shrink: 0;
    }

    .cookie-btn {
        font: inherit;
        font-size: 14px;
        line-height: 1;
        padding: 12px 20px;
        border-radius: 0;
        cursor: pointer;
        white-space: nowrap;
        transition: background-color 0.2s, color 0.2s, border-color 0.2s;
    }

    .cookie-btn-primary {
        background: #000;
        color: #fff;
        border: 1px solid #000;

        &:hover {
            background: #333;
            border-color: #333;
        }
    }

    .cookie-btn-secondary {
        background: transparent;
        color: #000;
        border: 1px solid #000;

        &:hover {
            background: #000;
            color: #fff;
        }
    }

    @media (max-width: grid-breakpoint(sm)) {
        padding: 16px 0;

        .cookie-row {
            flex-direction: column;
            align-items: stretch;
            gap: 16px;
        }

        .cookie-message p.text {
            font-size: 13px;
        }

        .cookie-buttons {
            flex-direction: column;

            .cookie-btn {
                width: 100%;
            }
        }
    }
}

.cookie-fade-enter-active,
.cookie-fade-leave-active {
    transition: transform 0.4s cubic-bezier(0.39, 0.575, 0.565, 1), opacity 0.4s;
}

.cookie-fade-enter-from,
.cookie-fade-leave-to {
    transform: translateY(100%);
    opacity: 0;
}
</style>
